/* tslint:disable */
/* eslint-disable */
import { BaseModel } from '@/core/models/base.model';
import { FormGroup, FormControl, FormArray, AbstractControl, Validators } from '@angular/forms';

// All imports for FormGroups..

export interface IProjectDataDisplayModel {
  kurzTitel?: null | string;
  projektEnd?: null | string;
  projektStart?: null | string;
  projektbeschreibung?: null | string;
  projektbeteiligte?: null | string;
  title?: null | string;
}
export class ProjectDataDisplayModel extends BaseModel implements IProjectDataDisplayModel {
  kurzTitel?: null | string;
  projektEnd?: null | string;
  projektStart?: null | string;
  projektbeschreibung?: null | string;
  projektbeteiligte?: null | string;
  title?: null | string;
}
class BaseProjectDataDisplayModelFormGroup extends FormGroup {
  private static _instance: ProjectDataDisplayModelFormGroup;
  
  public static get Instance(): ProjectDataDisplayModelFormGroup {
    this._instance = new ProjectDataDisplayModelFormGroup({
      kurzTitel: new FormControl(null),
      projektEnd: new FormControl(null),
      projektStart: new FormControl(null),
      projektbeschreibung: new FormControl(null),
      projektbeteiligte: new FormControl(null),
      title: new FormControl(null),
    });

    return this._instance;
  }
}


export class ProjectDataDisplayModelFormGroup extends BaseProjectDataDisplayModelFormGroup {
  public get KurzTitel(): FormControl {
    return this.controls["kurzTitel"] as FormControl;
  }
  public get ProjektEnd(): FormControl {
    return this.controls["projektEnd"] as FormControl;
  }
  public get ProjektStart(): FormControl {
    return this.controls["projektStart"] as FormControl;
  }
  public get Projektbeschreibung(): FormControl {
    return this.controls["projektbeschreibung"] as FormControl;
  }
  public get Projektbeteiligte(): FormControl {
    return this.controls["projektbeteiligte"] as FormControl;
  }
  public get Title(): FormControl {
    return this.controls["title"] as FormControl;
  }
  

}

export module ProjectDataDisplayModelForm
  {
    export class FormFields
    {
      static _kurzTitel: string = "kurzTitel";
      static _projektEnd: string = "projektEnd";
      static _projektStart: string = "projektStart";
      static _projektbeschreibung: string = "projektbeschreibung";
      static _projektbeteiligte: string = "projektbeteiligte";
      static _title: string = "title";
    }
  }

